const COMMON_PASSWORDS = new Set(['12345678', '123456789', 'password', 'qwerty123', 'qwertyuiop', 'administrator', 'admin123', 'devconnect']);
const LEVELS = [['Пустой пароль', 'Введите пароль длиной не менее 12 символов.'], ['Очень слабый', 'Добавьте длину и не используйте распространённые комбинации.'], ['Слабый', 'Добавьте ещё несколько символов и разные типы знаков.'], ['Хороший', 'Пароль подходит, но дополнительная длина сделает его надёжнее.'], ['Надёжный', 'Хорошая длина и разнообразие символов.']];
export default class PasswordStrengthService {
  evaluate(password, username, email) {
    if (username === void 0) {
      username = '';
    }
    if (email === void 0) {
      email = '';
    }
    const value = String(password || '');
    if (!value) return this.result(0);
    const normalized = value.toLowerCase();
    const usernamePart = String(username || '').trim().toLowerCase();
    const emailPart = String(email || '').split('@')[0].trim().toLowerCase();
    let score = 0;

    // Длина даёт основной вклад: длинная парольная фраза полезнее формального набора спецсимволов.
    if (value.length >= 8) score += 1;
    if (value.length >= 12) score += 1;
    if (value.length >= 16) score += 1;
    const characterGroups = [/[a-zа-яё]/u, /[A-ZА-ЯЁ]/u, /\d/u, /[^\p{L}\p{N}]/u].filter(pattern => pattern.test(value)).length;
    if (characterGroups >= 3) score += 1;
    if (characterGroups === 4 && value.length >= 12) score += 1;

    // Словарные и персональные совпадения важнее формальной сложности и снижают итоговую оценку.
    if (COMMON_PASSWORDS.has(normalized) || /(.)\1{4,}/u.test(value) || /(?:12345|qwerty|йцукен)/iu.test(value)) score = Math.min(score, 1);
    if (usernamePart.length >= 3 && normalized.includes(usernamePart) || emailPart.length >= 3 && normalized.includes(emailPart)) score = Math.min(score, 2);
    if (value.length < 8) score = 1;
    return this.result(Math.max(1, Math.min(4, score)));
  }
  result(score) {
    const [label, hint] = LEVELS[score];
    return {
      score,
      label,
      hint,
      progress: score * 25
    };
  }
}
flarum.reg.add('devconnect-security', 'forum/service/PasswordStrengthService', PasswordStrengthService);